<template>
  <div class="portefeuille-section portefeuille-module portefeuille-documents-module">
    <v-container class="section-content">
      <button class="back-button" @click="goBack">
        <span class="fa fa-arrow-left"></span> {{ $t('common.back') }}
      </button>

      <div class="page-header">
        <div class="header-content">
          <h1 class="page-title">{{ $t('portefeuille.documents') }}</h1>
          <p class="page-subtitle">{{ $t('portefeuille.documents_subtitle') }}</p>
        </div>
      </div>

      <div class="toolbar-section">
        <div class="search-box">
          <span class="fa fa-search search-icon"></span>
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="$t('portefeuille.search_document')"
            class="search-input"
          />
        </div>
        <button class="add-button" @click="openAddDialog">
          <span class="fa fa-plus"></span> {{ $t('common.add') }}
        </button>
      </div>

      <div v-if="loading" class="empty-state">
        <span class="fa fa-spinner fa-spin empty-icon"></span>
        <p class="empty-text">{{ $t('common.loading') }}</p>
      </div>

      <div v-else-if="filteredDocuments.length === 0" class="empty-state">
        <span class="fa fa-file empty-icon"></span>
        <p class="empty-text">{{ $t('portefeuille.no_documents') }}</p>
      </div>

      <div v-else class="table-wrapper">
        <table class="documents-table">
          <thead>
            <tr>
              <th>{{ $t('portefeuille.document') }}</th>
              <th>{{ $t('portefeuille.document_type') }}</th>
              <th>DATE D'UPLOAD</th>
              <th>ÉTAT</th>
              <th>{{ $t('common.action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in filteredDocuments" :key="document._id" class="table-row">
              <td class="document-cell" @click="viewDocument(document)" style="cursor: pointer;">
                <span class="document-icon fa fa-file"></span>
                <div class="document-info">
                  <div class="document-name">{{ document.type_document }}</div>
                  <div class="document-details">Cliquer pour visualiser</div>
                </div>
              </td>
              <td>{{ document.type_document }}</td>
              <td>{{ document.date_upload }}</td>
              <td><span class="status-badge">{{ document.etat }}</span></td>
              <td class="action-cell">
                <div class="action-buttons">
                  <button class="action-btn" @click.stop="editDocument(document)" title="Modifier">
                    <span class="fa fa-edit"></span>
                  </button>
                  <button class="action-btn" @click.stop="downloadDocumentBrowser(document)" title="Telecharger">
                    <span class="fa fa-download"></span>
                  </button>
                  <button class="action-btn" @click.stop="requestDeleteDocument(document._id)" title="Supprimer">
                    <span class="fa fa-trash"></span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-container>

    <v-dialog v-model="itemDialog" max-width="600" persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-orange">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields">
                <div class="field-title font-weight-bold">
                  {{ editingItem ? 'Modifier un document' : 'Ajouter un document' }}
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="field-group field-default">
                      <label class="field-label">Type de document <span style="color: #e74c3c;">*</span></label>
                      <v-autocomplete
                        v-model="formData.type_document"
                        :items="documentTypes"
                        dense
                        outlined
                        clearable
                        placeholder="Sélectionner..."
                        class="field-autocomplete"
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-sm-12">
                    <div class="file-upload">
                      <label for="file-input" class="file-label">
                        <span class="fa fa-upload"></span>
                        {{ editingItem ? 'Remplacer le fichier' : 'Telecharger le fichier' }}
                        <span v-if="!editingItem" style="color: #e74c3c; margin-left: 5px;">*</span>
                      </label>
                      <input id="file-input" type="file" @change="onFileSelected" accept=".pdf,.doc,.docx,.jpg,.png" style="display: none;">
                      <p v-if="selectedFile" class="file-name">{{ selectedFile.name }}</p>
                      <p v-else-if="editingItem" class="file-name">Fichier actuel conserve si vous ne choisissez rien</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="itemDialog = false">Annuler</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="saveDocument">Enregistrer</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="460" persistent>
      <v-card elevation="24" class="border-radius portefeuille-modal-accent-orange">
        <v-card-text style="background: #fafafa">
          <div class="wizard-tab-content">
            <div role="tabpanel" class="wizard-tab-container">
              <div class="fields text-center">
                <div class="field-title font-weight-bold">Supprimer</div>
                <div class="field-sub-title">{{ $t('common.confirm_delete', 'Êtes-vous sûr ?') }}</div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button type="button" class="wizard-btn" @click="cancelDeleteDocument">Annuler</button>
              </div>
              <div class="wizard-footer-right">
                <button type="button" class="wizard-btn" @click="confirmDeleteDocument">Supprimer</button>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import DocumentService from '../../../services/portefeuille/DocumentService'

export default {
  name: 'PortefeuilleDocuments',
  data() {
    return {
      searchQuery: '',
      itemDialog: false,
      deleteDialog: false,
      pendingDeleteId: null,
      editingItem: null,
      selectedFile: null,
      documentTypes: [
        'carte identite',
        'passeport',
        'carte grise',
        'permis de conduire',
        'PV Constat'
      ],
      formData: {
        type_document: '',
        file: null
      }
    }
  },
  computed: {
    ...mapState('documents', ['loading']),
    ...mapGetters('documents', ['listeDocuments']),
    filteredDocuments() {
      if (!this.searchQuery) return this.listeDocuments
      const query = this.searchQuery.toLowerCase()
      return this.listeDocuments.filter(document =>
        String(document.type_document || '').toLowerCase().includes(query) ||
        String(document.etat || '').toLowerCase().includes(query)
      )
    }
  },
  methods: {
    ...mapActions('documents', [
      'fetchDocuments',
      'addDocument',
      'updateDocument',
      'deleteDocument'
    ]),

    showError(message) {
      // Fermer tous les toasts existants avant d'afficher un nouveau
      this.$toasted.clear()
      this.$toasted.show(message, {
        theme: 'toasted-primary',
        position: 'top-center',
        type: 'error',
        duration: 3000,
        singleton: true
      })
    },

    async loadDocuments() {
      try {
        await this.fetchDocuments()
      } catch (error) {
        this.$toasted.show(this.$t('common.error_loading', 'Erreur de chargement'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      }
    },

    resetForm() {
      this.selectedFile = null
      this.editingItem = null
      this.formData = { type_document: '', file: null }
    },

    openAddDialog() {
      this.resetForm()
      this.itemDialog = true
    },

    editDocument(document) {
      this.selectedFile = null
      this.editingItem = document
      this.formData = {
        type_document: document.type_document || '',
        file: null
      }
      this.itemDialog = true
    },

    onFileSelected(event) {
      this.selectedFile = event.target.files[0]
      this.formData.file = this.selectedFile || null
    },

    requestDeleteDocument(id) {
      this.pendingDeleteId = id
      this.deleteDialog = true
    },

    cancelDeleteDocument() {
      this.pendingDeleteId = null
      this.deleteDialog = false
    },

    async confirmDeleteDocument() {
      if (!this.pendingDeleteId) return

      try {
        await this.deleteDocument(this.pendingDeleteId)
        this.$toasted.show(this.$t('common.deleted', 'Supprimé avec succès'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } catch (error) {
        this.$toasted.show(this.$t('common.error_delete', 'Erreur de suppression'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      } finally {
        this.cancelDeleteDocument()
      }
    },

    viewDocument(document) {
      if (document.lien_document) {
        window.open(document.lien_document, '_blank')
      } else {
        this.$toasted.show(this.$t('portefeuille.no_link', 'Aucun lien disponible'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
      }
    },

    async saveDocument() {
      if (!this.formData.type_document) {
        this.showError(this.$t('portefeuille.document_type_required'))
        return
      }

      if (!this.editingItem && !this.selectedFile) {
        this.showError(this.$t('portefeuille.document_file_required'))
        return
      }

      try {
        if (this.editingItem) {
          await this.updateDocument({
            id: this.editingItem._id,
            documentData: this.formData
          })
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.updated'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        } else {
          await this.addDocument(this.formData)
          this.$toasted.clear()
          this.$toasted.show(this.$t('common.saved'), {
            theme: 'toasted-primary',
            position: 'top-center',
            type: 'success',
            duration: 3000,
            singleton: true
          })
        }

        this.itemDialog = false
        this.resetForm()
      } catch (error) {
        this.showError(this.$t('common.error_saving'))
      }
    },

    getFileExtension(url) {
      if (!url) return 'file'
      const match = url.match(/\.([^./?#]+)(?:[?#]|$)/)
      return match ? match[1] : 'file'
    },

    async downloadDocumentBrowser(selectedDocument) {
      if (!selectedDocument.lien_document) {
        this.$toasted.show(this.$t('portefeuille.no_link', 'Aucun lien disponible'), {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 3000
        })
        return
      }

      try {
        // Construire le nom du fichier avec l'extension
        const fileName = `${selectedDocument.type_document}-${Date.now()}.${this.getFileExtension(selectedDocument.lien_document)}`

        // Utiliser la nouvelle fonction downloadFile du DocumentService
        await DocumentService.downloadFile(selectedDocument.lien_document, fileName)

        this.$toasted.show('Téléchargement terminé', {
          theme: 'toasted-primary',
          position: 'top-center',
          type: 'success',
          duration: 2000
        })
      } catch (error) {
        console.error('Erreur téléchargement:', error)
        this.$toasted.show(error.message || 'Impossible de télécharger le fichier', {
          theme: 'toasted-primary',
          position: 'top-center',
          type: 'error',
          duration: 3000
        })
      }
    },

    goBack() {
      this.$router.push({ name: 'portefeuille' })
    }
  },

  mounted() {
    this.loadDocuments()
  }
}
</script>

<style scoped>
.portefeuille-section {
  padding: 2rem;
  padding-top: 100px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.portefeuille-modal-accent-orange {
  --custom-color-primary: #ffa409;
}


.section-header {
  margin-bottom: 1.5rem;
}

.page-header {
  margin-bottom: 1.5rem;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 3.2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.page-subtitle {
  font-size: 1.4rem;
  color: #666;
  margin: 0;
}

.back-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: #333;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
  margin-bottom: 1rem;
}

.back-button:hover {
  color: #ffa409;
}

.section-title {
  flex: 1;
  font-size: 1.75rem;
  font-weight: 700;
  color: #000;
  margin: 0;
  font-family: 'Lato', sans-serif;
}

.add-button {
  background: #ffa409;
  border: none;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Lato', sans-serif;
}

.toolbar-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  gap: 1rem;
}

.search-box {
  flex: 1;
  position: relative;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
}

.search-icon {
  color: #999;
  margin-right: 0.8rem;
  font-size: 0.875rem;
}

.search-input {
  border: none;
  outline: none;
  flex: 1;
  font-size: 1.1rem;
  color: #333;
  background: transparent;
  font-family: 'Lato', sans-serif;
}

.search-input::placeholder {
  color: #999;
}

.add-button:hover {
  background: #ff9500;
  box-shadow: 0 4px 12px rgba(255, 164, 9, 0.3);
}

.section-content {
  /* Vuetify v-container padding par defaut */
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  background: white;
  border-radius: 8px;
}

.empty-icon {
  font-size: 4rem;
  color: #ddd;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1.25rem;
  color: #999;
  margin: 0;
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.documents-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
}

.documents-table thead {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.documents-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}

.documents-table th:last-child {
  text-align: right;
}

.table-row {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #fafafa;
}

.table-row td {
  padding: 1rem;
  color: #333;
}

.document-cell {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.document-icon {
  font-size: 1.5rem;
  color: #ffa409;
}

.document-info {
  display: flex;
  flex-direction: column;
}

.document-name {
  font-weight: 600;
  color: #1a1a1a;
}

.document-details {
  font-size: 0.85rem;
  color: #999;
}

.status-badge {
  display: inline-block;
  background: #e8f5e9;
  color: #2e7d32;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
}

.action-cell {
  text-align: right;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.action-btn {
  background: transparent;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #f0f0f0;
  color: #ffa409;
}

.input-field {
  margin-bottom: 1rem;
}

.field-autocomplete {
  margin-top: 0.5rem;
}

.field-autocomplete >>> .v-input__control {
  min-height: 45px;
}

.field-autocomplete >>> .v-text-field__details {
  display: none;
}

.file-upload {
  border: 2px dashed #ddd;
  border-radius: 6px;
  padding: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
  background: #f9f9f9;
}

.file-label {
  display: inline-block;
  background: #ffa409;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.file-label:hover {
  background: #ff9500;
}

.file-name {
  color: #2e7d32;
  margin: 1rem 0 0 0;
  font-size: 0.9rem;
  font-weight: 600;
}

@media only screen and (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: stretch;
  }

  .back-button,
  .add-button {
    justify-content: center;
    font-size: 1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }

  .section-subtitle,
  .page-subtitle {
    font-size: 1rem;
  }

  .portefeuille-section {
    padding: 1rem;
    padding-top: 80px;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .documents-table {
    font-size: 0.95rem;
  }

  .documents-table th {
    font-size: 0.85rem;
  }

  .documents-table th,
  .documents-table td {
    padding: 0.75rem 0.5rem;
  }

  .empty-text {
    font-size: 1rem;
  }
}
</style>
